import { createEvent } from "effector";
function OnFetchDataEvt() {
    const onFetchDataEvt = createEvent("OnFetchDataEvt");
    onFetchDataEvt.watch(() => console.log("OnFetchDataEvt"));
    return onFetchDataEvt;
}
export default OnFetchDataEvt;
//# sourceMappingURL=OnFetchDataEvt.js.map